import { PublicServiceMissionsSliceType } from '../../../../types/slice';
import { toTextFromProp } from '../../fields/text';

export const principlesSlice = ({ primary, items }) => ({
  type: PublicServiceMissionsSliceType.PRINCIPLES,
  items,
  title: toTextFromProp('title', primary),
});
